var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.rows, function (row, index) {
      return _c(
        "div",
        { key: "row-" + index, staticClass: "my-2" },
        [
          _c(
            "b-row",
            {
              staticClass: "align-items-center my-4",
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: { height: "2rem", width: _vm.generateTitle() + "%" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            _vm._l(_vm.generateColumns(), function (column, idx) {
              return _c(
                "b-col",
                { key: "column-" + idx },
                [
                  _c("b-skeleton", {
                    attrs: {
                      animation: "fade",
                      width: "30%",
                      height: "0.5rem",
                    },
                  }),
                  _vm._v(" "),
                  _c("b-skeleton", {
                    attrs: {
                      type: "input",
                      animation: "fade",
                      width: "95%",
                      height: "1.5rem",
                    },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c("b-skeleton", {
            staticClass: "my-5",
            attrs: { width: "100%", height: "0.2rem" },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }